import type { FC, ReactNode } from 'react';

import { Box, Stack } from '@mui/material';

type Props = {
    title?: string;
    header?: ReactNode;
    children?: ReactNode;
};

export const Page: FC<Props> = ({ title, header, children }) => (
    <Box>
        {title && <title>{title}</title>}
        <Stack pl="1.5%" pr="1.5%">
            {header && (
                <Box sx={{ display: 'block', textAlign: 'left' }}>
                    {header}
                </Box>
            )}
            {children}
        </Stack>
    </Box>
);
